export default function(target, type, selection) {
  this.target = target;
  this.type = type;
  this.selection = selection;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-brush/src/event.js
// module id = 232
// module chunks = 0 1 2 3 4